/* jadore-dobor.js — dobór pielęgnacji (konsultacja online) + widok planu.
   Silnik: Supabase edge `beauty-plan` (create / finalize / get_plan).
   Konfiguracja: window.JDB_CFG {endpoint, anon, mode:'dobor'|'view', logged, email, metaPlanId, pageUrl} */
(function () {
  "use strict";
  var CFG = window.JDB_CFG || {};
  var root = document.getElementById("jdbRoot");
  if (!root) return;

  var state = {
    source: null, skin: null, zones: [], goals: [], uses: [], dislikes: [], routine: null,
    sourceOther: "", skinOther: "", zonesOther: "", dislikesOther: "",
    whatMatters: "", currentProducts: "", treatments: "", sensitive: "", sensitiveOk: false, email: "",
    planId: null, plan: null, code: null, unlocked: false
  };
  window.jdbState = state;

  var TOTAL = 10;
  var bar = document.getElementById("jdbBar");
  function el(id) { return document.getElementById(id); }
  function esc(s) { return String(s == null ? "" : s).replace(/[<>&"]/g, function (c) { return { "<": "&lt;", ">": "&gt;", "&": "&amp;", '"': "&quot;" }[c]; }); }
  function money(p) { if (p == null || p === "") return ""; var n = Number(p); if (!isFinite(n)) return ""; return n.toFixed(2).replace(".", ",") + " zł"; }

  var jdbBooted = false;
  function show(n) {
    root.querySelectorAll(".screen").forEach(function (s) { s.classList.toggle("active", s.dataset.s === String(n)); });
    if (bar) {
      var pct = typeof n === "number" ? (n / TOTAL * 100) : (n === "busy" ? 92 : 100);
      bar.style.width = pct + "%";
    }
    // scroll tylko w trakcie interakcji i gdy sekcja jest widoczna —
    // pierwszy render (init) nie może ściągać strony w dół (bug mobile)
    var canScroll = jdbBooted && root.offsetParent !== null;
    jdbBooted = true;
    if (!canScroll) return;
    var y = root.getBoundingClientRect().top + window.pageYOffset - 80;
    window.scrollTo({ top: Math.max(0, y), behavior: "smooth" });
  }
  function busy(title, sub) {
    var t = el("jdbBusyT"), s = el("jdbBusyS");
    if (t) t.textContent = title || "Chwileczkę…";
    if (s) s.textContent = sub || "";
    show("busy");
  }

  // ── nawigacja ──
  window.jdbGo = function (n) { show(n); };
  window.jdbNext = function (step) { show(step + 1); };
  window.jdbSkipZones = function () {
    state.zones = []; state.zonesOther = "";
    root.querySelectorAll('[data-q="zones"] .chip').forEach(function (c) { c.setAttribute("aria-pressed", "false"); });
    show(4);
  };

  // ── chipsy ──
  root.querySelectorAll(".chips").forEach(function (box) {
    var multi = box.dataset.multi === "1", q = box.dataset.q;
    if (!q) return;
    box.addEventListener("click", function (e) {
      var chip = e.target.closest(".chip"); if (!chip) return;
      var otherKey = chip.dataset.other;
      if (q === "zones") {
        var on = chip.getAttribute("aria-pressed") === "true";
        chip.setAttribute("aria-pressed", String(!on));
        state.zones = Array.prototype.slice.call(root.querySelectorAll('[data-q="zones"]')).reduce(function (acc, g) {
          g.querySelectorAll('[aria-pressed="true"]').forEach(function (c) { acc.push({ zone: g.dataset.zone, concern: c.textContent.trim() }); });
          return acc;
        }, []);
        return;
      }
      if (multi) {
        var on2 = chip.getAttribute("aria-pressed") === "true";
        chip.setAttribute("aria-pressed", String(!on2));
        state[q] = Array.prototype.map.call(box.querySelectorAll('[aria-pressed="true"]'), function (c) { return c.textContent.trim(); });
      } else {
        box.querySelectorAll(".chip").forEach(function (c) {
          c.setAttribute("aria-pressed", "false");
          if (c.dataset.other) { var w = el("ow-" + c.dataset.other); if (w) w.classList.remove("on"); }
        });
        chip.setAttribute("aria-pressed", "true");
        state[q] = chip.textContent.trim();
      }
      if (otherKey) { var w2 = el("ow-" + otherKey); if (w2) w2.classList.toggle("on", chip.getAttribute("aria-pressed") === "true"); }
      var btn = box.closest(".screen").querySelector("[data-next]");
      var filled = multi ? state[q].length > 0 : !!state[q];
      if (btn) btn.disabled = !filled;
    });
  });

  var EMAIL_RE = /^\S+@\S+\.\S+$/;
  window.jdbCheckPlanGate = function () {
    var need = (state.sensitive || "").trim().length > 0;
    var lab = el("jdbSensConsent"), btn = el("jdbPlanBtn");
    if (lab) lab.style.display = need ? "flex" : "none";
    var sensitiveOk = !(need && !state.sensitiveOk);
    var emailOk = EMAIL_RE.test((state.email || "").trim());
    var mk = el("jdbMkacc"), rg = el("jdbReg");
    // dla zalogowanej klientki (mk/rg nie istnieją w DOM) zgody nie są wymagane
    var consentOk = (!mk && !rg) || (mk && mk.checked && rg && rg.checked);
    if (btn) btn.disabled = !(sensitiveOk && emailOk && consentOk);
  };

  // ── stan między nawigacjami (rejestracja konta = przeładowanie strony) ──
  function saveLocal() {
    try {
      localStorage.setItem("jdb_plan_id", state.planId || "");
      var copy = {}; for (var k in state) if (k !== "plan") copy[k] = state[k];
      localStorage.setItem("jdb_state", JSON.stringify(copy));
    } catch (e) { /* prywatny tryb */ }
  }
  function loadLocal() {
    try {
      var pid = localStorage.getItem("jdb_plan_id") || "";
      var st = JSON.parse(localStorage.getItem("jdb_state") || "null");
      if (st) for (var k in st) if (k in state) state[k] = st[k];
      if (pid) state.planId = pid;
    } catch (e) { /* ignore */ }
  }

  // ── API ──
  function api(body) {
    return fetch(CFG.endpoint, {
      method: "POST",
      headers: { "Authorization": "Bearer " + CFG.anon, "Content-Type": "application/json" },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  // ── krok „Przygotuj mój plan" ──
  window.jdbPrepPlan = function () {
    var profile = {
      source: state.source, source_other: state.sourceOther,
      skin: state.skin, skin_other: state.skinOther,
      zones: state.zones, zones_other: state.zonesOther,
      goals: state.goals, uses: state.uses,
      dislikes: state.dislikes, dislikes_other: state.dislikesOther,
      routine: state.routine,
      what_matters: state.whatMatters, current_products: state.currentProducts,
      treatments_done: state.treatments,
      sensitive_text: state.sensitive, sensitive_consent: !!state.sensitiveOk,
      consent_version: "v1"
    };
    busy("Przygotowujemy Twój plan…", "Nasza specjalistka dobiera produkty i wskazówki pod Twoje odpowiedzi.");
    var mail = (state.email || "").trim().toLowerCase();
    api({ profile: profile, save: true, website: "", email: (/^\S+@\S+\.\S+$/.test(mail) ? mail : null) }).then(function (r) {
      if (!r || !r.success || !r.plan) throw new Error((r && r.error) || "bez planu");
      state.planId = r.plan_id; state.plan = r.plan; state.unlocked = false;
      saveLocal();
      renderTeaser(r.plan);
      show(9);
    }).catch(function () {
      busy("Coś przerwało połączenie…", "Odśwież stronę i spróbuj ponownie — Twoje odpowiedzi zachowałyśmy.");
      saveLocal();
    });
  };

  // ── render: teaser (przed dołączeniem — bez cen) ──
  function productCard(p, withPrice, brandChip) {
    var img = p.image_url ? '<span class="ri"><img loading="lazy" src="' + esc(p.image_url) + '" alt=""></span>' : '<span class="ri"></span>';
    var right = withPrice && p.price != null ? '<span class="rprice">' + money(p.price) + "</span>"
      : (brandChip ? '<span class="brandchip">' + esc(p.vendor || "") + "</span>" : "");
    var inner = img +
      '<span style="flex:1;min-width:0"><span class="rn" style="display:block">' + esc(p.title) + "</span>" +
      (p.vendor ? '<span class="rd" style="display:block">' + esc(p.vendor) + "</span>" : "") +
      (p.why ? '<span class="why" style="display:block">' + esc(p.why) + "</span>" : "");
    // bez cen (teaser) nie linkujemy do sklepu — PDP i tak nie pokaże ceny, to myli;
    // zamiast tego kierunek: załóż konto → pełny plan
    if (!withPrice) {
      return '<span class="rec" style="cursor:default">' + inner +
        '<span class="see" style="display:block">Pełny plan i cena — po dołączeniu ↓</span></span>' + right + "</span>";
    }
    return '<a class="rec" href="/products/' + esc(p.handle) + '">' + inner +
      '<span class="see" style="display:block">Zobacz w sklepie →</span></span>' + right + "</a>";
  }

  function renderTeaser(plan) {
    el("jdbIntro").textContent = plan.intro || "Przygotowałyśmy Twój plan pielęgnacji.";
    var m = el("jdbMatter");
    if ((state.whatMatters || "").trim()) { m.innerHTML = "<b>Napisałaś, że zależy Ci na:</b> „" + esc(state.whatMatters.trim()) + "” — plan układamy wokół tego."; m.style.display = "block"; }
    else m.style.display = "none";
    var iss = el("jdbIssues");
    if (plan.issues && plan.issues.length) { iss.innerHTML = plan.issues.map(esc).join("<br>"); iss.style.display = "block"; }
    else iss.style.display = "none";
    el("jdbEstLbl").textContent = "Na początek — najważniejszy krok";
    var first = (plan.products || [])[0];
    el("jdbEst").innerHTML = first ? productCard(first, false, true) : "";
    el("jdbLockbox").style.display = "block";
    var cta = el("jdbUnlockCta");
    cta.style.display = "block";
    cta.textContent = CFG.logged ? "Przypisz plan do mojego konta — odbierz pełny plan" : "Załóż konto — odbierz pełny plan i −5%";
    el("jdbFullPlan").style.display = "none";
    el("jdbPlanCode").style.display = "none";
  }

  // ── render: pełny plan (po dołączeniu — z cenami) ──
  function renderFull(plan, code) {
    el("jdbIntro").textContent = plan.intro || "Twój plan pielęgnacji.";
    el("jdbMatter").style.display = "none";
    var iss = el("jdbIssues");
    if (plan.issues && plan.issues.length) { iss.innerHTML = plan.issues.map(esc).join("<br>"); iss.style.display = "block"; } else iss.style.display = "none";
    el("jdbEstLbl").textContent = "Dobrane dla Ciebie";
    var prods = plan.products || [];
    var core = prods.filter(function (p) { return (p.vendor || "") === "estGen"; });
    if (!core.length) core = prods.slice(0, 3);
    var alts = prods.filter(function (p) { return core.indexOf(p) === -1; });
    el("jdbEst").innerHTML = core.map(function (p) { return productCard(p, true, false); }).join("");
    el("jdbLockbox").style.display = "none";
    el("jdbUnlockCta").style.display = "none";
    el("jdbFullPlan").style.display = "block";
    // plan AM/PM
    function olify(list) {
      return "<ol>" + (list || []).map(function (s) {
        return "<li>" + esc(s.step || "") + (s.note ? "<small>" + esc(s.note) + "</small>" : "") + "</li>";
      }).join("") + "</ol>";
    }
    el("jdbPlan").innerHTML =
      '<div><p class="ph">Rano</p>' + olify(plan.plan_am) + "</div>" +
      '<div><p class="ph">Wieczorem</p>' + olify(plan.plan_pm) + "</div>" +
      ((plan.weekly && plan.weekly.length) ? '<div><p class="ph">W tygodniu</p>' + olify(plan.weekly) + "</div>" : "");
    // składniki
    function ulify(a) { return "<ul>" + (a || []).map(function (x) { return "<li>" + esc(x) + "</li>"; }).join("") + "</ul>"; }
    el("jdbIng").innerHTML =
      '<div class="seek"><p class="ih">Szukaj</p>' + ulify(plan.ingredients_seek) + "</div>" +
      '<div class="avoid"><p class="ih">Ostrożnie z</p>' + ulify(plan.ingredients_avoid) + "</div>";
    // rytm dnia + oczekiwania — sekcje opcjonalne (starsze plany ich nie mają)
    var lw = el("jdbLifeWrap");
    if (lw) {
      if (plan.lifestyle && plan.lifestyle.length) {
        el("jdbLife").innerHTML = plan.lifestyle.map(function (x) {
          return '<div class="treat"><div class="ti">✦</div><div><p class="td">' + esc(x) + "</p></div></div>";
        }).join("");
        lw.style.display = "";
      } else lw.style.display = "none";
    }
    var ew = el("jdbExpectWrap");
    if (ew) {
      if (plan.expectations) { el("jdbExpect").textContent = plan.expectations; ew.style.display = ""; }
      else ew.style.display = "none";
    }
    // zabiegi
    el("jdbTreat").innerHTML = (plan.treatments || []).map(function (t) {
      return '<div class="treat"><div class="ti">✦</div><div><p class="tn">' + esc(t.name) + '</p><p class="td">' + esc(t.why || "") + "</p></div></div>";
    }).join("") || '<p class="rd" style="padding:8px 0">Zabiegi dobierzemy wspólnie na wizycie.</p>';
    // alternatywy
    el("jdbAlt").innerHTML = alts.length ? alts.map(function (p) { return productCard(p, true, true); }).join("")
      : '<p class="rd" style="padding:8px 0">Trzon planu w pełni pokrywa Twoje potrzeby.</p>';
    // recap
    var chipsSrc = [].concat(state.skin || [], state.goals || [], (state.zones || []).map(function (z) { return z.concern + " (" + z.zone + ")"; }), state.dislikes || []);
    var rec = el("jdbRecap");
    if (chipsSrc.length) { rec.innerHTML = chipsSrc.slice(0, 12).map(function (c) { return '<span class="rc">' + esc(c) + "</span>"; }).join(""); rec.parentElement.parentElement.style.display = ""; }
    else rec.parentElement.parentElement.style.display = "none";
    // kod
    var pc = el("jdbPlanCode");
    if (code) { el("jdbCode2").textContent = code; pc.style.display = "flex"; } else pc.style.display = "none";
  }

  window.jdbUnlock = function () {
    if (state.plan) { renderFull(state.plan, state.code); show(9); }
  };

  // ── dołączenie: konto → finalize ──
  window.jdbToAccount = function () {
    saveLocal();
    if (CFG.logged && CFG.email) { finalizeFlow(); return; }
    // zgody i e-mail zebrane już na ekranie 8 — nie zatrzymujemy się na ekranie 10,
    // od razu otwieramy logowanie Shopify (ekran 10 zostaje tylko jako fallback UI
    // pod przyciskiem, na wypadek popup-blockera obsłużonego w jdbGoLogin()).
    show(10);
    jdbGoLogin();
  };
  function finalizeFlow() {
    var pid = state.planId || (function () { try { return localStorage.getItem("jdb_plan_id"); } catch (e) { return null; } })();
    if (!pid) { show(0); return; }
    busy("Przypisujemy plan do Twojego konta…", "Zapisujemy dobór w Twojej karcie Klientki.");
    api({ action: "finalize", plan_id: pid, email: CFG.email, website: "" }).then(function (r) {
      if (!r || !r.success) throw new Error((r && r.error) || "finalize");
      state.plan = r.plan || state.plan; state.code = r.discount_code || null; state.unlocked = true; state.planId = pid;
      saveLocal();
      var codeEl = el("jdbCode"); if (codeEl) codeEl.textContent = state.code || "—";
      var cbox = el("jdbCodeBox"); if (cbox) cbox.style.display = state.code ? "flex" : "none";
      var rep = el("jdbRepeat"); if (rep) rep.style.display = r.repeat ? "block" : "none";
      var mailNote = el("jdbMailNote"); if (mailNote) mailNote.style.display = r.mailed ? "block" : "none";
      var fp = el("jdbSuccessProd");
      var first = ((r.plan || {}).products || [])[0];
      if (fp && first) {
        fp.innerHTML = '<div class="img">' + (first.image_url ? '<img src="' + esc(first.image_url) + '" alt="">' : "") + "</div>" +
          '<div><p class="name">' + esc(first.title) + '</p><div class="cat">' + esc(first.vendor || "") + "</div>" +
          '<span class="price-live">' + money(first.price) + "</span></div>";
      }
      show(12);
    }).catch(function () {
      busy("Nie udało się przypisać planu…", "Odśwież stronę — spróbujemy ponownie. Plan jest bezpiecznie zapisany.");
    });
  }

  // ── widok „Mój plan" ──
  function viewFlow(pid) {
    busy("Otwieramy Twój plan…", "");
    api({ action: "get_plan", plan_id: pid, website: "" }).then(function (r) {
      if (!r || !r.success || !r.plan) throw new Error("brak");
      state.plan = r.plan; state.code = r.discount_code; state.planId = pid;
      if (r.status === "active") { renderFull(r.plan, r.discount_code); show(9); }
      else if (CFG.logged && CFG.email) {
        // zalogowana klientka ze szkicem planu (rejestracja poza flow doboru) —
        // dokańczamy przypisanie automatycznie: tag, kod −5%, ceny
        busy("Przypisujemy plan do Twojego konta…", "Odblokowujemy ceny i Twój kod −5%.");
        api({ action: "finalize", plan_id: pid, email: CFG.email, website: "" }).then(function (f) {
          if (f && f.success && f.plan) {
            state.plan = f.plan; state.code = f.discount_code || null;
            renderFull(f.plan, state.code); show(9);
          } else { renderTeaser(r.plan); show(9); }
        }).catch(function () { renderTeaser(r.plan); show(9); });
      }
      else { renderTeaser(r.plan); show(9); }
    }).catch(function () { show("empty"); });
  }

  // ── start ──
  function init() {
    var qs = new URLSearchParams(location.search);
    if (CFG.mode === "view") {
      var pid = qs.get("plan") || CFG.metaPlanId || (function () { try { return localStorage.getItem("jdb_plan_id"); } catch (e) { return null; } })();
      loadLocal();
      if (pid && /^[0-9a-f-]{36}$/.test(pid)) { viewFlow(pid); return; }
      // zalogowana bez linku/metafielda (inne urządzenie) — znajdź plan po e-mailu konta
      if (CFG.logged && CFG.email) {
        busy("Szukamy Twojego planu…", "");
        api({ action: "my_plan", email: CFG.email, website: "" }).then(function (r) {
          if (r && r.success && r.plan_id) viewFlow(r.plan_id); else show("empty");
        }).catch(function () { show("empty"); });
        return;
      }
      show("empty");
      return;
    }
    // tryb dobor
    if (CFG.logged && CFG.email) {
      state.email = CFG.email;
      var ef = el("jdbEmailField"); if (ef) { ef.value = CFG.email; ef.readOnly = true; }
      jdbCheckPlanGate();
    }
    if (qs.get("krok") === "final") { loadLocal(); if (CFG.logged && CFG.email) { finalizeFlow(); } else { show(10); } return; }
    if (root.querySelector(".form-errors")) { loadLocal(); show(10); return; }
    // zalogowana bez uprawnień, ale z niedokończonym planem (rejestracja poza flow,
    // np. przez panel konta Shopify) — dokończ przypisanie w tle i odśwież ceny
    if (CFG.logged && CFG.email && !CFG.pro) {
      var autoDone = false;
      try { autoDone = sessionStorage.getItem("jdb_autofin") === "1"; } catch (e) {}
      if (!autoDone) {
        var markDone = function () { try { sessionStorage.setItem("jdb_autofin", "1"); } catch (e) {} };
        var autoFin = function (pid) {
          api({ action: "finalize", plan_id: pid, email: CFG.email, website: "" }).then(function (r) {
            markDone();
            if (r && r.success) location.reload();
          }).catch(function () {});
        };
        // najpierw plan powiązany z e-mailem konta (my_plan); localStorage tylko jako
        // rezerwa (formularz bez e-maila) — na wspólnym komputerze może być cudzy/stary
        api({ action: "my_plan", email: CFG.email, website: "" }).then(function (r) {
          if (r && r.success && r.plan_id) { autoFin(r.plan_id); return; }
          var lpid = CFG.metaPlanId || (function () { try { return localStorage.getItem("jdb_plan_id"); } catch (e) { return null; } })();
          if (lpid && /^[0-9a-f-]{36}$/.test(lpid)) { autoFin(lpid); } else { markDone(); }
        }).catch(function () {});
      }
    }
    show(0);
  }

  window.jdbGoLogin = function () {
    saveLocal();
    // Nowe konta Shopify nie wracają na return_url — logowanie w nowej karcie,
    // a tu zostaje przycisk „Zalogowałam się — pokaż mój plan".
    var url = "/account/login?return_url=" + encodeURIComponent((CFG.pageUrl || "/pages/dobor-pielegnacji") + "?krok=final");
    var w = window.open(url, "_blank");
    if (!w) { location.href = url; return; }
    var btn = el("jdbRegBtn"); if (btn) btn.style.display = "none";
    var after = el("jdbAfterLogin"); if (after) after.style.display = "block";
  };

  init();
})();
